import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import guard from './guard'
const router = new VueRouter({
   
    routes: [
        // 首页
        {
            path: "/",
            name: 'home',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/home/index.vue")
        },
        {
            path: "/jobs",
            name: 'jobs',
            meta: {
                showTab: false,
                private: false,
            },
            component: () =>
                import("@/views/hrm/jobs/index.vue"),
        },
        // 客户回访
        {
            path: "/job/detail/:id",
            meta: {
                showTab: false,
                private: false,
            },
            component: () =>
                import("@/views/hrm/jobs/detail.vue"),
        },
        {
            path: "/resume/:id",
            name: 'resume',
            meta: {
                showTab: false,
                private: false,
            },
            component: () =>
                import("@/views/hrm/resume"),
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import("@/views/login")
        },

        // 个人中心
        {
            path: "/my",
            meta: {
                showTab: true,

            },
            component: () =>
                import("@/views/my/index.vue"),
        },
        // 设置退出
        {
            path: "/my/personsetting",
            meta: {
                showTab: false,
                private: true
            },
            component: () =>
                import("@/views/my/personsetting.vue")
        },
        // 客户管理入口页
        {
            path: "/crm",
            name: 'crm',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/index.vue")
        },
       
        {
            path: "/customerinfo",
            name: 'customerinfo',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/customer/customerinfo/index.vue")
        },
        {
            path: "/crmregister/:id",
            name: 'crmregister',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/customer/register/index.vue")
        },
        
        {
            path: "/questionnaire/:id",
            name: 'questionnaire',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/customer/questionnaire/index.vue")
        },
        {
            path: "/crmcreate/:id",
            name: 'crmcreate',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/customer/create/index.vue")
        },

        {
            path: "/crmulist",
            name: 'crmulist',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/customer/index.vue")
        },
        {
            path: "/rengou",
            name: 'rengou',
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/rengou/index.vue")
        },
        {
            path: "/crmlog",
            meta: {
                showTab: true,
            },
            component: () =>
                import("@/views/crm/returnvisit/log/index.vue"),
        },
        // 客户回访
        {
            path: "/returnvisit/:tel",
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/returnvisit/detail.vue"),
        },

        // 客户回访
        {
            path: "/visit/:isgroup",
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/visit"),
        },
        {
            path: "/crmpublic",
            meta: {
                showTab: true,
                private: true,
            },
            component: () =>
                import("@/views/crm/公共池"),
        }


    ],
})
// 路由跳转检查
router.beforeEach(guard.beforeEach)
router.afterEach(guard.afterEach)
export default router